/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Action_ShareInputs */

const en_recipe_action_share = /** @type {(inputs: Recipe_Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const de_recipe_action_share = /** @type {(inputs: Recipe_Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Recipe_Action_ShareInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_action_share = /** @type {((inputs?: Recipe_Action_ShareInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Action_ShareInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_action_share(inputs)
	return en_recipe_action_share(inputs)
});